/**
 * tools.ts - Tool definitions for FMwvTool
 * 
 * CHANGE HISTORY:
 * - 251114_2110 [complete] danielbeer: Created for SideMenu integration
 */

import type { Tool } from './types';

export const TOOLS: Tool[] = [
  // Document Tools
  {
    id: 'pdf-viewer',
    name: 'PDF Viewer',
    description: 'View and interact with PDF documents',
    icon: '📕',
    category: 'document'
  },
  {
    id: 'office-viewer',
    name: 'Office Viewer',
    description: 'View Word, Excel, and PowerPoint files',
    icon: '📄',
    category: 'document'
  },
  {
    id: 'file-loader',
    name: 'File Loader',
    description: 'Load and process various file types',
    icon: '📁',
    category: 'document'
  },
  
  // Data Tools
  {
    id: 'transform-distill',
    name: 'Transform & Distill',
    description: 'Transform and filter data',
    icon: '🔄',
    category: 'data'
  },
  {
    id: 'field-matcher',
    name: 'Field Matcher',
    description: 'Match and map fields for data import',
    icon: '🎯',
    category: 'data'
  },
  
  // UI/View Tools
  {
    id: 'table-viewer',
    name: 'Table Viewer',
    description: 'Advanced data grid with sorting and filtering',
    icon: '📊',
    category: 'ui'
  },
  {
    id: 'tag-manager',
    name: 'Tag Manager',
    description: 'Manage tags with autocomplete',
    icon: '🏷️',
    category: 'ui'
  },
  {
    id: 'picker',
    name: 'Picker',
    description: 'Keyboard-navigable selection menu',
    icon: '🎯',
    category: 'ui'
  },
  {
    id: 'selectr-examples',
    name: 'Selectr Examples',
    description: 'Selection component examples',
    icon: '✨',
    category: 'ui'
  },
  {
    id: 'outliner',
    name: 'Outliner',
    description: 'Hierarchical data outliner with keyboard navigation',
    icon: '📋',
    category: 'data'
  },
  
  // FileMaker Integration
  {
    id: 'filemaker-bridge',
    name: 'FileMaker Bridge',
    description: 'Script integration and callbacks',
    icon: '🌉',
    category: 'integration'
  },
  {
    id: 'rmemb',
    name: 'Rmemb',
    description: 'Remember field values across sessions',
    icon: '💾',
    category: 'integration'
  },
  
  // Utility/System
  {
    id: 'setup-wizard',
    name: 'Setup Wizard',
    description: 'Initial configuration guide',
    icon: '🚀',
    category: 'ui'
  },
  {
    id: 'documentation',
    name: 'Documentation',
    description: 'Help and integration guides',
    icon: '📚',
    category: 'ui'
  },
  {
    id: 'quick-reference',
    name: 'Quick Reference',
    description: 'Quick reference guide',
    icon: '📝',
    category: 'ui'
  },
  {
    id: 'plugins',
    name: 'Plugins',
    description: 'Manage plugins and extensions',
    icon: '🔌',
    category: 'ui'
  },
  {
    id: 'settings',
    name: 'Settings',
    description: 'Application settings',
    icon: '⚙️',
    category: 'ui'
  },
  {
    id: 'dev',
    name: 'Dev Panel',
    description: 'Developer tools and debugging',
    icon: '🛠️',
    category: 'ui'
  }
];
